export default __webpack_public_path__ + "static/media/brittany_prude.11f72777.jpeg";